import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 35 38"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#222120",
  "fill-rule": "evenodd",
  d: "M17.5 20.591c9.205 0 16.667 7.495 16.667 16.742H.833c0-9.247 7.462-16.742 16.667-16.742zM17.473.667c4.725 0 8.554 3.75 8.554 8.376 0 4.626-3.83 8.376-8.554 8.376S8.92 13.67 8.92 9.043c0-4.626 3.83-8.376 8.554-8.376z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render() { return h(NuxtIcon, {icon: {render}}) } }